import { ActionCenterService } from '@app/core/services/action-center.service';
import { IActionHandler } from '../interfaces';
import { DeleterFactory } from '../actions/deletion/factory';
import { TableType } from '@app/pages/cmms/types';
import { AuDialogService } from '@app/core/services/au-dialog.service';
import { TranslateService } from '@tolgee/ngx';

export class DeletionActionHandler implements IActionHandler {
	private readonly itemTypeMap = {
		[TableType.FILES]: 'file',
		[TableType.ASSETS]: 'asset',
		[TableType.WORK_ORDER]: 'work order',
		[TableType.REQUESTS]: 'request',
		[TableType.INCIDENTS]: 'incident',
	};

	constructor(
		private actionCenterService: ActionCenterService,
		private deleterFactory: DeleterFactory,
		private readonly dialogService: AuDialogService,
		private readonly translateService: TranslateService
	) {}

	createDeletionDialogFn(itemType: string) {
		return (pks: string[], callback: (pks: string[]) => void) => {
			const dialogRef = this.dialogService.openDeleteDialog({
				itemType,
				title: this.translateService.instant('delete'),
				description: this.getDeleteConfirmationMessage(itemType, pks),
				confirmButton: this.translateService.instant('delete'),
			});

			this.dialogService.closedByEnter(dialogRef).subscribe(async confirm => {
				if (confirm) {
					callback(pks);
				}
			});
		};
	}

	private getDeleteConfirmationMessage(itemType: string, pks: string[]): string {
		const itemTypeTranslated = this.translateService.instant(itemType).toLowerCase();

		const message = this.translateService.instant('action_center_delete_confirmation', {
			type: itemTypeTranslated,
			count: pks.length,
		});

		const fileWarning = this.deleteFileDesc(itemType);
		return message + fileWarning;
	}

	private deleteFileDesc(itemType) {
		let severalFiles = true;
		let endText = '';
		if (this.actionCenterService.selectedEntities.length === 1) {
			severalFiles = false;
		}

		if (itemType === 'file') {
			this.actionCenterService.selectedEntities.forEach(element => {
				if (element.locations?.length > 1) {
					endText = this.translateService.instant('action_center_delete_file_warning', {
						count: severalFiles,
					});
				}
			});
		}
		return endText;
	}

	handleAction(): void {
		const tableType = this.actionCenterService.tableType.value;
		const itemType = this.itemTypeMap[tableType];

		const deleter = this.deleterFactory.createDeleter(
			tableType,
			this.createDeletionDialogFn(itemType)
		);

		deleter.delete(
			this.actionCenterService.selectedEntities.map(entity =>
				entity.pk ? entity.pk : entity
			)
		);
		setTimeout(() => {
			this.actionCenterService.closeActionCenter$.next();
		});
	}
}
